import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { filter, withLatestFrom, concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';

import { GetTracksSuccess } from '../action-creators';
import { GET_TRACKS_SUCCESS } from '../actions';
import { NoOp } from '../../ui/action-creators';
import AppState from '../../state';

export const notifyInvalidTrackEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetTracksSuccess>(GET_TRACKS_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([action]) =>
        !action.disableCheck &&
        action.tracks.some((t) => t.status === 'invalid')
    ),
    concatMap(([action, state]) => {
      const duplicatedTracks = action.tracks.filter(
        (t) => t.status === 'invalid'
      );

      return duplicatedTracks.map((track) => {
        const status = state.assets.statuses[track.id as string];

        if (!status || !status.isrc) {
          return new NoOp();
        }
        return new NoOp();

        // Commented in case this is back

        // const artistId = state.artist.active?.id;
        // const releaseId = state.release.release?.id;

        // return new ShowSnackbar(`TRACK.${track.id}`, {
        //   title: `Invalid track: ${ track?.title }`,
        //   text: <Translate id="TRACK.ACR_DUPLICATE" />,
        //   action: 'Edit',
        //   hideDismiss: true,
        //   to:  `/release/${artistId}/${releaseId}/track/${track.id}`
        // })
      });
    })
  );
